import React from 'react';
import Headerr from '../components/layout/header';
import Navbar from '../components/layout/navbar';
import Sec1bookingp3 from '../sections/sec1-booking3';
import { useState } from 'react';
import { useEffect } from 'react';
import Preloader from '../components/common/preloader';

const Bookingp3 = () => {
              const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />
    return ( 
          <>
                    <main className='home-background'>
                        <Headerr />
                        <Sec1bookingp3 />
                        <Navbar />
                    </main>
        </>
     );
}
 
export default Bookingp3;